<div class="kt-portlet">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle class="kt-portlet__head kt-portlet__head__custom">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">{{data.title}}</h3>
        </div>
    </div>
    <div class="kt-form">
        <div class="kt-portlet__body">
			<div class="form-group kt-form__group row">
				<div class="col-lg-12">
					<mat-dialog-content class="mat-typography" [innerHTML]="data.message">
					</mat-dialog-content>
				</div>
			</div>
		</div>
        <div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
            <div class="kt-form__actions kt-form__actions--sm">
                <kt-button-v1
                    *ngIf="!data.isCancelDisabled"
                    variant="stroked"
                    theme="muted"
                    [label]="data.cancel || 'Cancel'"
                    (btnClick)="closeDialog(false)">
                </kt-button-v1>
                <kt-button-v1
                    variant="flat"
                    theme="dark"
                    [label]="data.ok || 'Ok'"
                    (btnClick)="closeDialog(true)">
                </kt-button-v1>
            </div>
        </div>
    </div>
</div>